export const createVocabularyTermKey = (
  term: string | undefined | null,
  scenarioName?: string | null
) => {
  if (!term) return null;
  const normalizedTerm = term.trim().toLowerCase();
  if (!normalizedTerm) return null;

  const normalizedScenario =
    (scenarioName ?? "default").trim().toLowerCase() || "default";

  return `${normalizedScenario}::${normalizedTerm}`;
};
